import { reducer as toastrReducer } from 'react-redux-toastr';
import auth from './auth';
import publicConfigs from './publicConfigs';

const coreReducers = {
    auth,
    toastr: toastrReducer,
    publicConfigs,
};

export default coreReducers;
